import { render, staticRenderFns } from "./IrisTableNoRowsOverlay.vue?vue&type=template&id=7b403b36&"
import script from "./IrisTableNoRowsOverlay.vue?vue&type=script&lang=ts&"
export * from "./IrisTableNoRowsOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports